import React from "react";
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail, ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="39617" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-5 w-24 bg-muted/20 animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-primary/70 hover:text-[#A68B59] transition-colors text-sm font-medium tracking-wide">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="bg-[#f8f9fa] text-primary pt-24 pb-12 border-t border-primary/5 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none select-none flex items-start justify-start overflow-hidden z-0 p-8">
        <span className="text-[35vw] font-black tracking-tighter leading-none">50,000+</span>
      </div>

      <div className="container ml-0 mr-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          
          {}
          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-4">
              <div className="text-[10px] tracking-[0.3em] text-[#A68B59] font-bold uppercase">Precision Craftsmanship</div>
              <Button variant="ghost" asChild className="p-0 h-auto hover:bg-transparent block w-fit">
                <Link to="#">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/simprotile_logo.png" alt="SimProTiling" className="h-8 w-auto object-contain brightness-0 opacity-90" />
                </Link>
              </Button>
            </div>
            <p className="text-primary/70 text-sm leading-relaxed max-w-xs font-sans">
              SimProTiling is a premier London tiling specialist with 11 years of experience. We deliver luxury tile installations, wet rooms, and full bathroom refurbishments with architectural precision.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-8">
            <h3 className="font-bold text-primary tracking-[0.2em] uppercase text-[11px]">Navigation</h3>
            <MenuProvider menu_id="17" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-8">
            <h3 className="font-bold text-primary tracking-[0.2em] uppercase text-[11px]">London Service Areas</h3>
            <p className="text-primary/70 text-sm font-sans leading-relaxed">
              Mainly serving North London and surrounding areas with expert commercial and residential renovation services.
            </p>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {["Edgware", "Barnet", "Enfield", "Finchley", "Hendon", "Mill Hill", "Golders Green", "Colindale", "Brent Cross", "Harrow", "Stanmore", "Wembley", "Kingsbury", "Watford"].map((area, i) => <li key={i} data-index={i} className="text-primary/60 text-[11px] flex items-center gap-2 font-sans uppercase tracking-wider">
                  <span className="w-1 h-1 rounded-none bg-[#A68B59] shrink-0" />
                  {area}
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-8">
            <h3 className="font-bold text-primary tracking-[0.2em] uppercase text-[11px]">Connect With Us</h3>
            <ul className="flex flex-col gap-5">
              <li className="flex items-start gap-4 text-sm text-primary/70 font-sans">
                <MapPin className="w-4 h-4 mt-0.5 text-[#A68B59] shrink-0" />
                <span>Specialist Tile & Bathroom Services Across London</span>
              </li>
              <li className="flex items-center gap-4 text-sm text-primary/70 font-sans">
                <Phone className="w-4 h-4 text-[#A68B59] shrink-0" />
                <Link to="tel:07467562688" className="hover:text-[#A68B59] transition-colors font-medium">
                  07467 562688
                </Link>
              </li>
              <li className="flex items-center gap-4 text-sm text-primary/70 font-sans">
                <Mail className="w-4 h-4 text-[#A68B59] shrink-0" />
                <Link to="mailto:simprotile@gmail.com" className="hover:text-[#A68B59] transition-colors font-medium">
                  simprotile@gmail.com
                </Link>
              </li>
            </ul>
            
            <div className="flex gap-5 mt-4">
              {[{
              icon: Facebook,
              href: "#"
            }, {
              icon: Twitter,
              href: "#"
            }, {
              icon: Instagram,
              href: "#"
            }, {
              icon: Linkedin,
              href: "#"
            }].map((social, i) => <Link key={i} data-index={i} to={social.href} className="text-primary/40 hover:text-[#A68B59] transition-all duration-300" aria-label="Social Media Link">
                  <social.icon className="w-5 h-5" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="bg-primary/10 mb-10" />

        {}
        <div className="flex flex-col md:flex-row items-start justify-start gap-8 text-[10px] text-primary/50 uppercase tracking-[0.2em] font-sans">
          <div className="flex flex-col md:flex-row items-start gap-4 md:gap-12 text-left">
            <p>&copy; {currentYear} SimProTiling London. All rights reserved.</p>
            <div className="flex gap-8">
              <Link to="#" className="hover:text-[#A68B59] transition-colors">Privacy Policy</Link>
              <Link to="#" className="hover:text-[#A68B59] transition-colors">Terms of Service</Link>
            </div>
          </div>

          <Button variant="outline" size="sm" onClick={scrollToTop} className="gap-3 border-primary/10 rounded-none hover:bg-[#A68B59] hover:text-white hover:border-[#A68B59] transition-all duration-500 uppercase text-[9px] tracking-[0.25em] h-10 px-6">
            Back to Top
            <ArrowUp className="w-3.5 h-3.5" />
          </Button>
        </div>
      </div>
    </section>;
}